import { URLS, ENABLE_ALL_INTERNAL } from '../constants';



export interface UserAccessResponse {
  allowed: boolean;
  user_id: string;
}

export class UserAccessService {
  /**
   * Check user access via API
   * @param userId The user's email ID
   * @returns Promise<boolean> True if user is allowed, false otherwise
   */
  private static async checkUserAccessViaAPI(userId: string): Promise<boolean> {
    try {
      const response = await fetch(`${URLS.CHECK_USER_ACCESS_URL}/${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.adobeIMS?.getAccessToken()?.token}`
        },
      });

      if (response.ok) {
        const data: UserAccessResponse = await response.json();
        return data.allowed;
      } else {
        console.warn('Failed to check user access:', response.status, response.statusText);
        return false;
      }
    } catch (error) {
      console.error('Error checking user access:', error);
      return false;
    }
  }

  /**
   * Check if a user is allowed to use the chat assistant input box
   * @param userId The user's email ID
   * @returns Promise<boolean> True if user is allowed, false otherwise
   */
  static async checkUserAccess(userId: string): Promise<boolean> {
    if (!userId) {
      return false;
    }

    // Check API logic if ENABLE_ALL_INTERNAL is false
    if (!ENABLE_ALL_INTERNAL) {
      return this.checkUserAccessViaAPI(userId);
    } else {
      try {
        // Get IMS profile from session storage
        const imsProfile = sessionStorage.getItem('adobeid_ims_profile');
        if (!imsProfile) {
          console.warn('No IMS profile found in session storage');
          return false;
        }

        const profile = JSON.parse(imsProfile);
        
        if (!profile.email || profile.emailVerified !== 'true') {
          return false;
        }

        return true;
      } catch (error) {
        console.error('Error parsing IMS profile:', error);
        return false;
      }
    }
  }
}